import { render } from "./TheInputTextArea.vue?vue&type=template&id=3bcf249e"
import script from "./TheInputTextArea.vue?vue&type=script&lang=js"
export * from "./TheInputTextArea.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__